import React from "react";
import FeatureCard from "./components/FeatureCard";
import Navbar from "./components/Navbar";
import appDetails from "./data";
import Footer from "./components/Footer";

function AppIntroPage() {
  const [selectedImage, setSelectedImage] = React.useState(null);

  return (
    <div
      style={{
        fontFamily:
          "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        color: "#4b3621",
        backgroundColor: "#ffffff",
        minHeight: "100vh",
      }}
    >
      <Navbar currentPath="/app" />

      {/* 介绍区 */}
      <section style={{ textAlign: "center", padding: "4rem 0 3rem" }}>
        <div
          style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 1.5rem" }}
        >
          <h2
            style={{
              fontSize: "2.5rem",
              marginBottom: "1rem",
              color: "#8b4513",
            }}
          >
            关于 {appDetails.name}
          </h2>
          <p
            style={{
              maxWidth: "800px",
              margin: "0 auto 2rem",
              fontSize: "1.125rem",
              color: "#7a6650",
              lineHeight: "1.7",
            }}
          >
            {appDetails.description}
          </p>
        </div>
      </section>

      {/* 核心功能区：响应式网格，不出现横向滚动 */}
      <section
        style={{
          backgroundColor: "#ffffff",
          padding: "3rem 0",
          borderTop: "1px solid #f0e6db",
        }}
      >
        <div
          style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 1.5rem" }}
        >
          <h2
            style={{
              textAlign: "center",
              fontSize: "2.5rem",
              marginBottom: "2rem",
              color: "#8b4513",
            }}
          >
            核心功能
          </h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
              gap: "1.5rem",
            }}
          >
            {appDetails.features.map((feature, index) => (
              <FeatureCard key={index} feature={feature} />
            ))}
          </div>
        </div>
      </section>

      {/* 截图区：一行三张，按比例缩小，有间距 */}
      <section
        style={{
          backgroundColor: "#ffffff",
          padding: "3rem 0",
          borderTop: "1px solid #f0e6db",
        }}
      >
        <div
          style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 1.5rem" }}
        >
          <h2
            style={{
              textAlign: "center",
              fontSize: "2.5rem",
              marginBottom: "2rem",
              color: "#8b4513",
            }}
          >
            应用截图
          </h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "1.5rem",
            }}
          >
            {appDetails.screenshots.map((src, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                {/* 截图容器：加相对定位和过渡 */}
                <div
                  style={{
                    width: "100%",
                    overflow: "hidden",
                    borderRadius: "0.75rem",
                    boxShadow: "0 4px 12px rgba(139, 69, 19, 0.08)",
                    marginBottom: "0.75rem",
                    transition: "box-shadow 0.3s ease",
                    cursor: "pointer",
                  }}
                  onClick={() => setSelectedImage(src)}
                >
                  <img
                    src={src}
                    alt={`App Screenshot ${index + 1}`}
                    style={{
                      width: "100%",
                      height: "auto",
                      aspectRatio: "9 / 19.5",
                      objectFit: "cover",
                      display: "block",
                      transition: "transform 0.3s ease",
                    }}
                  />
                </div>
                {/* 说明文字 */}
                <div style={{ textAlign: "center", maxWidth: "90%" }}>
                  <h3
                    style={{
                      fontSize: "1.125rem",
                      fontWeight: "600",
                      color: "#8b4513",
                      marginBottom: "0.4rem",
                    }}
                  >
                    {appDetails.screenshotCaptions?.[index] ||
                      `功能展示 ${index + 1}`}
                  </h3>
                  <p
                    style={{
                      fontSize: "0.9rem",
                      color: "#7a6650",
                      lineHeight: "1.5",
                      margin: 0,
                    }}
                  >
                    {appDetails.screenshotDescriptions?.[index] ||
                      "直观的操作界面，让您轻松上手"}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 群聊二维码部分 */}
      <section
        style={{
          backgroundColor: "#f9f5f0",
          padding: "4rem 0",
          borderTop: "1px solid #f0e6db",
          borderBottom: "1px solid #f0e6db",
        }}
      >
        <div
          style={{ maxWidth: "900px", margin: "0 auto", padding: "0 1.5rem" }}
        >
          <h2
            style={{
              textAlign: "center",
              fontSize: "2.5rem",
              marginBottom: "1.5rem",
              color: "#8b4513",
            }}
          >
            加入群聊
          </h2>
          <p
            style={{
              textAlign: "center",
              maxWidth: "600px",
              margin: "0 auto 2.5rem",
              fontSize: "1.125rem",
              color: "#7a6650",
              lineHeight: "1.7",
            }}
          >
            扫码加入我们的群聊，与开发者直接交流，倾听更多思考者的故事
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                width: "220px",
                height: "220px",
                backgroundColor: "#ffffff",
                borderRadius: "1rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: "0 8px 20px rgba(139, 69, 19, 0.1)",
                marginBottom: "1.5rem",
                overflow: "hidden",
              }}
            >
              <img
                src={appDetails.qrcodes.QQgroup}
                alt="用户交流群二维码"
                style={{
                  width: "90%",
                  height: "90%",
                  objectFit: "contain",
                }}
              />
            </div>
            <p style={{ color: "#7a6650", fontSize: "1rem" }}>
              扫码加入，与万千用户一起探索
            </p>
          </div>
        </div>
      </section>

      {/* 下载区 */}
      <section
        id="download"
        style={{
          backgroundColor: "#ffffff",
          color: "#4b3621",
          textAlign: "center",
          padding: "4rem 0",
        }}
      >
        <div
          style={{ maxWidth: "900px", margin: "0 auto", padding: "0 1.5rem" }}
        >
          <h2
            style={{
              fontSize: "2.5rem",
              marginBottom: "1rem",
              color: "#8b4513",
            }}
          >
            准备好开始了吗？
          </h2>
          <p
            style={{
              fontSize: "1.25rem",
              marginBottom: "2rem",
              opacity: 0.9,
              color: "#7a6650",
            }}
          >
            立即下载 {appDetails.name}，开启全新体验。
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "1rem",
              flexWrap: "wrap",
            }}
          >
            <a
              href={appDetails.downloadLinks.ios}
              style={{
                padding: "0.875rem 1.75rem",
                fontSize: "1rem",
                fontWeight: "600",
                backgroundColor: "#c76b30",
                color: "#fff",
                border: "none",
                borderRadius: "0.5rem",
                textDecoration: "none",
                transition: "background-color 0.2s ease, transform 0.2s ease",
              }}
            >
              App Store
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />

      {/* 图片放大模态框 */}
      {selectedImage && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.85)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            cursor: "zoom-out",
          }}
          onClick={() => setSelectedImage(null)}
        >
          {/* 关闭按钮 */}
          <button
            onClick={() => setSelectedImage(null)}
            style={{
              position: "absolute",
              top: "1.5rem",
              right: "1.5rem",
              width: "40px",
              height: "40px",
              backgroundColor: "rgba(255,255,255,0.2)",
              border: "none",
              borderRadius: "50%",
              color: "#fff",
              fontSize: "1.5rem",
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              transition: "background-color 0.2s ease",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.35)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.2)")
            }
          >
            ×
          </button>

          <img
            src={selectedImage}
            alt="放大截图"
            style={{
              maxWidth: "90vw",
              maxHeight: "90vh",
              borderRadius: "0.75rem",
              boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
            }}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

      {/* 截图悬停效果 */}
      <style>{`
        img[alt^="App Screenshot"]:hover {
          transform: scale(1.02);
          box-shadow: 0 8px 24px rgba(139, 69, 19, 0.12);
        }
        div[style*="display: flex"][style*="flexDirection: column"]:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 28px rgba(139, 69, 19, 0.12);
        }
        @media (max-width: 768px) {
          section > div > h2 {
            font-size: 1.875rem !important;
          }
          div[style*="gridTemplateColumns: repeat(2, 1fr)"] {
            grid-template-columns: 1fr !important;
          }
          div[style*="gridTemplateColumns: repeat(auto-fit, minmax(240px, 1fr))"] {
            grid-template-columns: 1fr !important;
          }
          /* 截图区在小屏幕单列 */
          div[style*="gridTemplateColumns: repeat(3, 1fr)"] {
            grid-template-columns: 1fr !important;
          }
        }
        @media (max-width: 480px) {
          section > div > h2 {
            font-size: 1.5rem !important;
          }
          p[style*="fontSize: 1.125rem"] {
            font-size: 1rem !important;
          }
        }
        /* 截图悬停放大效果 */
        div[style*="overflow: hidden"][style*="borderRadius: 0.75rem"]:hover {
          box-shadow: 0 8px 24px rgba(139, 69, 19, 0.15);
        }
        div[style*="overflow: hidden"][style*="borderRadius: 0.75rem"]:hover img {
          transform: scale(1.05);
        }
      `}</style>
    </div>
  );
}

export default AppIntroPage;

// import React from "react";
// import FeatureCard from "./components/FeatureCard";
// import Navbar from "./components/Navbar";
// import appDetails from "./data";

// function AppIntroPage() {
//   return (
//     <div
//       style={{
//         fontFamily:
//           "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
//         color: "#4b3621",
//         backgroundColor: "#ffffff",
//         minHeight: "100vh",
//       }}
//     >
//       <Navbar currentPath="/app" />

//       {/* 介绍区 */}
//       <section style={{ textAlign: "center", padding: "4rem 0 3rem" }}>
//         <div
//           style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 1.5rem" }}
//         >
//           <h2
//             style={{
//               fontSize: "2.5rem",
//               marginBottom: "1rem",
//               color: "#8b4513",
//             }}
//           >
//             关于 {appDetails.name}
//           </h2>
//           <p
//             style={{
//               maxWidth: "800px",
//               margin: "0 auto 2rem",
//               fontSize: "1.125rem",
//               color: "#7a6650",
//               lineHeight: "1.7",
//             }}
//           >
//             {appDetails.description}
//           </p>
//         </div>
//       </section>

//       {/* 核心功能区：一行 4 个特色卡片，白色背景 */}
//       <section
//         style={{
//           backgroundColor: "#ffffff",
//           padding: "3rem 0",
//           borderTop: "1px solid #f0e6db",
//         }}
//       >
//         <div
//           style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 1.5rem" }}
//         >
//           <h2
//             style={{
//               textAlign: "center",
//               fontSize: "2.5rem",
//               marginBottom: "2rem",
//               color: "#8b4513",
//             }}
//           >
//             核心功能
//           </h2>
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(4, 1fr)",
//               gap: "1rem",
//             }}
//           >
//             {appDetails.features.map((feature, index) => (
//               <FeatureCard key={index} feature={feature} />
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* 截图区：一行 3 个，白色背景 */}
//       <section
//         style={{
//           backgroundColor: "#ffffff",
//           padding: "3rem 0",
//           borderTop: "1px solid #f0e6db",
//         }}
//       >
//         <div
//           style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 1.5rem" }}
//         >
//           <h2
//             style={{
//               textAlign: "center",
//               fontSize: "2.5rem",
//               marginBottom: "1.5rem",
//               color: "#8b4513",
//             }}
//           >
//             应用截图
//           </h2>
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(3, 1fr)",
//               gap: "0.75rem",
//             }}
//           >
//             {appDetails.screenshots.map((src, index) => (
//               <img
//                 key={index}
//                 src={src}
//                 alt={`App Screenshot ${index + 1}`}
//                 style={{
//                   width: "100%",
//                   borderRadius: "0.75rem",
//                   boxShadow: "0 4px 12px rgba(139, 69, 19, 0.08)",
//                   transition: "transform 0.3s ease, box-shadow 0.3s ease",
//                 }}
//               />
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* 新增的群聊二维码部分 */}
//       <section
//         style={{
//           backgroundColor: "#f9f5f0",
//           padding: "4rem 0",
//           borderTop: "1px solid #f0e6db",
//           borderBottom: "1px solid #f0e6db",
//         }}
//       >
//         <div
//           style={{ maxWidth: "900px", margin: "0 auto", padding: "0 1.5rem" }}
//         >
//           <h2
//             style={{
//               textAlign: "center",
//               fontSize: "2.5rem",
//               marginBottom: "1.5rem",
//               color: "#8b4513",
//             }}
//           >
//             加入群聊
//           </h2>
//           <p
//             style={{
//               textAlign: "center",
//               maxWidth: "600px",
//               margin: "0 auto 2.5rem",
//               fontSize: "1.125rem",
//               color: "#7a6650",
//               lineHeight: "1.7",
//             }}
//           >
//             扫码加入我们的群聊，与开发者直接交流，倾听更多思考者的故事
//           </p>
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               flexDirection: "column",
//             }}
//           >
//             <div
//               style={{
//                 width: "220px",
//                 height: "220px",
//                 backgroundColor: "#ffffff",
//                 borderRadius: "1rem",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 boxShadow: "0 8px 20px rgba(139, 69, 19, 0.1)",
//                 marginBottom: "1.5rem",
//                 overflow: "hidden",
//               }}
//             >
//               {/* 这里放置您的二维码图片 */}
//               <img
//                 src={appDetails.qrcodes.QQgroup}
//                 alt="用户交流群二维码"
//                 style={{
//                   width: "90%",
//                   height: "90%",
//                   objectFit: "contain",
//                 }}
//               />
//             </div>
//             <p style={{ color: "#7a6650", fontSize: "1rem" }}>
//               扫码加入，与万千用户一起探索
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* 下载区 */}
//       <section
//         id="download"
//         style={{
//           backgroundColor: "#ffffff",
//           color: "#4b3621",
//           textAlign: "center",
//           padding: "4rem 0",
//         }}
//       >
//         <div
//           style={{ maxWidth: "900px", margin: "0 auto", padding: "0 1.5rem" }}
//         >
//           <h2
//             style={{
//               fontSize: "2.5rem",
//               marginBottom: "1rem",
//               color: "#8b4513",
//             }}
//           >
//             准备好开始了吗？
//           </h2>
//           <p
//             style={{
//               fontSize: "1.25rem",
//               marginBottom: "2rem",
//               opacity: 0.9,
//               color: "#7a6650",
//             }}
//           >
//             立即下载 {appDetails.name}，开启全新体验。
//           </p>
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "center",
//               gap: "1rem",
//               flexWrap: "wrap",
//             }}
//           >
//             <a
//               href={appDetails.downloadLinks.ios}
//               style={{
//                 padding: "0.875rem 1.75rem",
//                 fontSize: "1rem",
//                 fontWeight: "600",
//                 backgroundColor: "#c76b30",
//                 color: "#fff",
//                 border: "none",
//                 borderRadius: "0.5rem",
//                 textDecoration: "none",
//                 transition: "background-color 0.2s ease, transform 0.2s ease",
//               }}
//             >
//               App Store
//             </a>
//             <a
//               href={appDetails.downloadLinks.android}
//               style={{
//                 padding: "0.875rem 1.75rem",
//                 fontSize: "1rem",
//                 fontWeight: "600",
//                 backgroundColor: "transparent",
//                 color: "#c76b30",
//                 border: "2px solid #c76b30",
//                 borderRadius: "0.5rem",
//                 textDecoration: "none",
//                 transition: "background-color 0.2s ease, transform 0.2s ease",
//               }}
//             >
//               Google Play
//             </a>
//           </div>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer
//         style={{
//           textAlign: "center",
//           padding: "2rem 0",
//           backgroundColor: "#f7f2eb",
//           color: "#7a6650",
//           fontSize: "0.95rem",
//         }}
//       >
//         <div
//           style={{ maxWidth: "900px", margin: "0 auto", padding: "0 1.5rem" }}
//         >
//           <p>
//             &copy; {new Date().getFullYear()} {appDetails.name}. All Rights
//             Reserved.
//           </p>
//         </div>
//       </footer>

//       {/* 截图悬停效果 */}
//       <style>{`
//         img[alt^="App Screenshot"]:hover {
//           transform: scale(1.05);
//           box-shadow: 0 8px 24px rgba(139, 69, 19, 0.12);
//         }
//       `}</style>
//     </div>
//   );
// }

// export default AppIntroPage;
